export const apiDateFormat = "yyyy-MM-dd";
export const datePickerFormat = "dd/MM/yyyy";

export const RENEWALS_ERROR_MESSAGE = {
  registration: "Registration required",
  dob: "Date of Birth required",
  postcode: "Postcode required",
};
